import { Injectable } from '@angular/core';

@Injectable()
export class AccessibilityService {
    static jsonData: object;
    static activityName: string;
    static isDataLoaded = false;

    static getAccessibilityData(id: string) {
        return this.jsonData[id];
    }
}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/services/accessibility.service.ts